const edit = () => {
    const  edits = document.querySelectorAll('.edit');
    if(edits) {
        edits.forEach(edit => {
            edit.addEventListener('click', (e)=> {
                e.preventDefault();
                edit.parentElement.nextElementSibling.removeAttribute('disabled');
                edit.parentElement.nextElementSibling.classList.add('editable');
            })
        })
    }
}

export default edit;